import { SYSActions, SYSState } from "../../../../../../../_ovlclient/src"
import { postRequest } from "../../../../../../../_ovlclient/src/effects"
import { T } from "../../../../../../../_ovlclient/src/global/globals"
import {
  FieldSetState,
  SYSFormState,
} from "../../../../../../../_ovlclient/src/library/forms/fieldapi"
import {
  ProcessEnd,
  ProcessStart,
} from "../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import { SnackAdd } from "../../../../../../../_ovlclient/src/library/snackapi"
import { validateCaptcha } from "../../../global/helpers"

export function dateDiffInDays(first: Date, second: Date) {
  // Take the difference between the dates and divide by milliseconds per day.
  // Round to nearest whole number to deal with DST.
  first.setHours(0)
  first.setMinutes(0)
  first.setSeconds(0)
  first.setMilliseconds(0)

  second.setHours(0)
  second.setMinutes(0)
  second.setSeconds(0)
  second.setMilliseconds(0)
  //@ts-ignore
  return Math.round((second - first) / (1000 * 60 * 60 * 24))
}

export const FindSlots = async (
  state: SYSState,
  actions: SYSActions,
  formState: SYSFormState,
  recaptchaToken?: string
) => {
  ProcessEnd("NewServiceSnackGetSlots")
  ProcessStart("NewServiceSnackGetSlots")
  FieldSetState(formState.fields["problemType"], false, {
    mode: "visible/readonly",
  })
  FieldSetState(formState.fields["group"], false, {
    mode: "visible/readonly",
  })
  FieldSetState(formState.fields["planningStartDate"], false, {
    mode: "visible/readonly",
  })
  try {
    if (!recaptchaToken) {
      recaptchaToken = <string>await validateCaptcha()
    }
    let apiUrl = state.ovl.apiUrl + "slotfinder/findslot"
    let problemData = state.app.global.SVL.lookups.problemType.data
    let problemType = state.app.global.SVL.NewService.selectedProblemType
    //debugger
    let res = await postRequest(apiUrl, {
      token: recaptchaToken,
      UserPlannedDate: formState.fields["planningStartDate"].convertedValue,
      Duration: problemData[problemType].Duration,
      Zip: state.app.global.SVL.NewService.slotFinder.zipCode,
      ProblemType: problemType,
    })

    if (res.data) {
      if (res.data.slots) {
        let resSlotData = res.data.slots.data
        Object.keys(resSlotData).forEach((f) => {
          let dateSplits = (
            resSlotData[f].DateDesc +
            " " +
            Math.ceil((resSlotData[f].Cost * (100 + resSlotData[f].Vat)) / 100)
          ).split(" ")
          let optionTranslateKey = "NewServicePlanningDateOption"
          if (resSlotData[f].Cost.toString() === "0") {
            optionTranslateKey = "NewServicePlanningDateOptionNoCost"
          }
          resSlotData[f].Params = dateSplits
          resSlotData[f].DateDesc = T(optionTranslateKey, dateSplits)
        })
        state.app.global.SVL.NewService.slotFinder.slots = res.data.slots
        let hasValues = Object.keys(resSlotData).length > 0
        if (!hasValues) {
          state.app.global.SVL.NewService.slotFinder.noSlotsFound = true
          SnackAdd(
            T("NewServiceSnackSlotfinderNoSlotsFound"),
            "Information",
            8000
          )
        }
        if (hasValues) {
          state.app.global.SVL.NewService.slotFinder.noSlotsFound = false

          FieldSetState(formState.fields["planningSlots"], true, {
            animate: "fade",
          })
        }
      }
    }
  } finally {
    FieldSetState(formState.fields["problemType"], true)
    FieldSetState(formState.fields["group"], true)
    FieldSetState(formState.fields["planningStartDate"], true)

    ProcessEnd("NewServiceSnackGetSlots")
  }
}
